
    import '/mnt/src/components/Flex/index.md?watch=parent';
    export const demoIndex = {
  ids: ["flex-demo-basic","flex-demo-justify","flex-demo-align"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Flex/index.md?type=demo')
};